import { depth } from '~/common/styles/depths'
import { POPPER_Z_INDEX } from '~/components/shared/Table/TableTabs'

const popoverBasePrimitives = {
  marginTop: '4px',
  alignItems: 'flex-start',
  borderRadius: '2px',
  boxShadow: depth[2],
  zIndex: POPPER_Z_INDEX,
  gap: '2px',
}

export const getPopoverPrimitives = (width?: number) => {
  if (width) {
    return getPopoverPrimitivesWithFixedWidth(width)
  } else {
    return popoverBasePrimitives
  }
}

const getPopoverPrimitivesWithFixedWidth = (width: number) => {
  return {
    ...popoverBasePrimitives,
    maxWidth: width,
    minWidth: width,
    width,
  }
}
